import { ReactComponent as AdditiveIcon} from "../../../assets/process_icons/additive.svg" 
import { ReactComponent as CastingIcon} from "../../../assets/process_icons/casting.svg" 
import { ReactComponent as ForgingIcon} from "../../../assets/process_icons/forging.svg" 
import { ReactComponent as HeatTreatmentIcon}  from "../../../assets/process_icons/heat_treatment.svg" 
import { ReactComponent as MachiningIcon } from "../../../assets/process_icons/machining.svg" 
import { ReactComponent as MoldingIcon } from "../../../assets/process_icons/molding.svg" 
import { ReactComponent as SheetMetalIcon } from "../../../assets/process_icons/sheet_metal.svg" 
import QuizIcon from '@mui/icons-material/Quiz';
import { useTheme } from '@mui/material/styles';


const iconMap: Record<string, any> = {
    additive: AdditiveIcon,
    casting: CastingIcon,
    forging: ForgingIcon,
    heat_treatment: HeatTreatmentIcon,
    machining: MachiningIcon,
    molding: MoldingIcon,
    sheet_metal: SheetMetalIcon
}


interface SVGIConProps {
    iconName: string
}

export const SVGIcon = (props: SVGIConProps) => {

    const theme = useTheme()

    const SVG = iconMap[props.iconName]
    return (
        <>
            {SVG ?
                    <SVG width={20} height={20} style={{color: theme.palette.text.primary}}/>
                :
                    <QuizIcon sx={{color: "text.primary"}}/>
            }
        </>
    )
}